import React, { useState } from 'react'
import { Modal } from 'react-bootstrap';
import EmailInput from '../EmailInput'
import PasswordInput from './PasswordInput';
import './EditUserPage.css'

const EditUserPage = ({ user, onDelete, onSave, onError, onCancel }) => {

  // If we have an onDelete callback the email is read-only
  const isForUserEdit = !!onDelete

  const [showDeleteModal, setShowDeleteModal] = useState(false)
  const confirmDelete =(user) => {
    setShowDeleteModal(true)
  }

  const handleDelete = () => {
    setShowDeleteModal(false)
    if (onDelete) {
      // Use the original user passed in, not the edited user
      onDelete(user)
    }
  }

  const cancelDelete = () => {
    setShowDeleteModal(false)
  }

  const handleSave = () => {
    if (onSave) {
      onSave(selectedUser)
    }
  }

  const handleCancel = () => {
    if (onCancel) {
      onCancel()
    }
  }

  const [selectedUser, setUser] = useState(user)
  const formSubmit = (event) => {
    event.preventDefault()
  }

  const handleRoleChange = (event) => {
    const newUser = {...selectedUser}
    newUser.role = event.target.value
    setUser(newUser)
  }

  const [emailValid, setEmailValidity] = useState(false)
  const onEmailChange = (value, isValid) => {
    setEmailValidity(isValid)
    const newUser = {...selectedUser}
    newUser._id = value 
    setUser(newUser)
  }

  const [passwordValid, setPasswordValidity] = useState(false)
  const onPasswordChange = (value, isValid) => {
    setPasswordValidity(isValid)
    const newUser = {...selectedUser}
    newUser.password = value
    setUser(newUser)
  }

  const disableSave = () => {
    if (!isForUserEdit) {
      return (!emailValid || !selectedUser._id) ||
             (!passwordValid || !selectedUser.password)
    }
  }
  // The edit page must have a user to edit, if there is no user then go back
  // Note: this can only be done after all react hooks have been used
  if (!user) {
    if (onError) {
      onError()
      return null
    }
  }

  /*
    This component does not use a Redux form. There is no external dependency on the 
    state from this form, so keeping the state internal to this component was preferable.
    In this instance, there was no need for form submission. The form tag has only been 
    added due to some hardcoded CSS styling. 
  */
  return (
    <React.Fragment>
      { isForUserEdit &&
        <h2>Edit User</h2>
      }
      { !isForUserEdit &&
        <h2>Create User</h2>
      }
      <form className="edit-user-panel" onSubmit={ formSubmit }>
        <EmailInput value={ selectedUser._id } onChange={ onEmailChange } readOnly={ isForUserEdit }/>

        { !isForUserEdit && 
          <PasswordInput value={ selectedUser.password } onChange={ onPasswordChange } />
        }

        <div className="form-group">
          <input className="form-check-input" 
                type="radio" id="user-role" 
                name="role" 
                value={ 'RNO' }
                onChange={ handleRoleChange }
                checked={ selectedUser.role !== 'Admin' }/>
          <label className="form-check-label" htmlFor="user-role">User</label>
        </div>

        <div className="form-group">
          <input className="form-check-input" 
                type="radio" 
                id="admin-role" 
                name="role" 
                value={ 'Admin' }
                onChange={ handleRoleChange }
                checked={ selectedUser.role === 'Admin' }/>
          <label className="form-check-label" htmlFor="admin-role">Admin</label>
        </div>

        <button className="float-right btn btn-primary" 
                onClick={ handleSave } 
                disabled={ disableSave() }>
          Save
        </button>
        <button className="float-right btn btn-secondary" onClick={ handleCancel }>
          Cancel
        </button>
        { onDelete && 
          <button className="float-right btn btn-danger" onClick={ confirmDelete }>
            Delete
          </button>
        }
      </form>
      { onDelete && 
        <Modal show={ showDeleteModal } onHide={ cancelDelete } >
          <Modal.Header closeButton>
            Confirm User Deletion
          </Modal.Header>
          <Modal.Body>
            Please confirm you wish to delete user: <code>{ user._id }</code>
          </Modal.Body>
          <Modal.Footer>
            <button type="submit" className="btn btn-secondary" onClick={ cancelDelete } data-testid="modal-user-cancel">Cancel</button>
            <button type="submit" className="btn btn-danger" onClick={ handleDelete } data-testid="modal-user-delete">Delete</button>
          </Modal.Footer>
        </Modal>
      }
    </React.Fragment>
  )
}

export default EditUserPage